export const generateNestedTree = data => {
  const tree = [];

  // 创建一个字典，用于快速查找每个节点的引用
  const nodeDict = {};

  // 将每个节点的引用存储到字典中
  data.forEach(node => {
    node.children = [];
    nodeDict[node.Id] = node;
  });

  // 遍历数据，将子节点添加到父节点的 children 数组中
  data.forEach(node => {
    const parentId = node.ParentId;
    if (parentId === '0') {
      // 如果 ParentId 为 '0'，将其视为最外层父级
      tree.push(node);
    } else if (nodeDict[parentId]) {
      // 如果找到父节点，则将当前节点添加到父节点的 children 数组中
      nodeDict[parentId].children.push(node);
    }
  });

  return tree;
};

export const buildTree = (data, parent_id) => {
  var tree = data
    .filter(item => item.ParentId === parent_id)
    .map(item => {
      var node = {
        ...item, // 保留除Id和Name之外的其他属性
        children: buildTree(data, item.Id)
      };
      if (node.children.length === 0) {
        node.children = [];
      }
      return node;
    });

  if (parent_id === null && tree.length === 0) {
    // 没有找到匹配的父级元素，将它们作为最外层的元素
    tree = data
      .filter(item => data.every(otherItem => otherItem.Id !== item.ParentId))
      .map(item => {
        return {
          ...item, // 保留除Id和Name之外的其他属性
          children: buildTree(data, item.Id)
        };
      });
  }

  return tree;
};
